import styled from "styled-components";

export const CharacteristicWrapper = styled.div`
  width: 210px;

  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  flex-direction: column;

  > p {
    font-size: 14px;
    font-weight: 500;

    color: #475569;
  }
`;

export const RadiosShell = styled.div`
  display: flex;
  width: 200px;
  margin: 6px 0 18px;
  padding: 4px;
  gap: 4px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-sizing: border-box;
`;

export const OptionChip = styled.div<{ $active: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 38px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease;
  background: ${({ $active }) => ($active ? "#e2e8f0" : "transparent")};

  &:hover {
    background: ${({ $active }) => ($active ? "#cbd5e1" : "#f8fafc")};
  }

  > p {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: #334155;
    user-select: none;
  }
`;
